import * as React from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import Radium, { StyleRoot } from 'radium';
import * as Tgcc from '../tgccGlobal';

const styles: { [key: string]: React.CSSProperties } = {
    footerContainer: {
      backgroundColor: 'rgb(206, 227, 188)',
      padding: '40px 20px',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      fontFamily: "'Montserrat', sans-serif",
      fontSize: '14px',
      color: '#333',
    },
    logo: {
      maxWidth: '13vh',
      marginBottom: '20px',
    },
    footerNavigation: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      marginBottom: '20px',
      flexWrap: 'wrap',
    },
    footerLink: {
      color: '#333',
      textDecoration: 'none',
      margin: '0 10px',
      fontWeight: 'bold',
      ':hover': {
        textDecoration: 'underline',
      },
    },
    contact: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      margin: '20px 0',
    },
    contactLink: {
      color: '#333',
      textDecoration: 'none',
      cursor: 'pointer',
      ':hover': {
        textDecoration: 'underline',
      },
    },
    socialMedia: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    socialIcon: {
      width: '30px',
      height: '30px',
      margin: '0 5px',
      filter: 'invert(30%) sepia(70%) saturate(1500%) hue-rotate(90deg) brightness(90%) contrast(90%)',
      ':hover': {
        filter: 'invert(50%) sepia(100%) saturate(1500%) hue-rotate(90deg) brightness(110%) contrast(110%)',
      },
    },
  };
  

 interface PapaJohnsFooterProps {
     Routes: typeof Tgcc.Routes;
   }
  
  // Define the props type for FooterLink
  interface FooterLinkProps {
    to: string;
    children?: React.ReactNode; // The children are now optional
    key: string;
  }
  
  // Define the FooterLink as a functional component
  const FooterLink = ({ to, children, key}: FooterLinkProps) => (
        <a href={to} style={styles.footerLink} key={key}>
      {children}
    </a>
  );
  
  // Define the class component for your footer
  class _PapaJohnsFooter extends React.Component<PapaJohnsFooterProps, any> {
    render() {
        const { Routes } = this.props;
        return (
          <div style={styles.footerContainer}>
            <img src={Tgcc.ResolveUrl('~/images/PrimaryLogo.svg')} alt="The Graphic Cow Company Logo" style={styles.logo} />
            <div style={styles.footerNavigation}>
              <FooterLink key="about" to={Routes.About}>About Us</FooterLink>
              <FooterLink key="contact" to={Routes.Contact}>Contact</FooterLink>
              <FooterLink key="shipping" to={Routes.MajorAccountShipping}>Shipping Info</FooterLink>
              <FooterLink key="faqs" to={Routes.MajorAccountsFAQ}>FAQs</FooterLink>
            </div>
            <div style={styles.contact}>
              <a key="email" href="mailto:sales@grafcow.com" style={styles.contactLink}>sales@grafcow.com</a>
              <a key="phone" href="tel:+18004723269" style={styles.contactLink}>(800) 472-3269</a>
            </div>
            <div style={styles.socialMedia}>
              {/* Add your social media icons here */}
            </div>
            <div key="copyright">© 2024 by The Graphic Cow Company</div>
          </div>
        );
      }
    }
    
  
  // Map state to props
  const mapStateToProps = (state: any) => ({
    Routes: Tgcc.Routes,
  });
  
  export const PapaJohnsFooter =
  Radium(connect(mapStateToProps)(_PapaJohnsFooter));
